<ng-container *ngIf="type">
    <div class="panel panel-white">
        <div class="panel-heading border-light">
            <h4 class="panel-title">{{ type.name }}s</h4>
            <ul class="panel-heading-tabs border-light">
                <li class="d-flex">
                    <div class="input-wrapper">
                        <i class="prefix fa-light fa-magnifying-glass"></i>
                        <input [value]="searchText()" (input)="handleSearchInput($event)" class="text-input" placeholder="Search" />
                        <button id="job-orders-filter-search-reset" class="suffix btn-flat btn-small square" (click)="searchText.set('')">
                            <i class="fa-light fa-xmark"></i>
                        </button>
                    </div>
                </li>
                <li>
                    <div class="btn-group">
                        <button
                            type="button"
                            class="btn btn-bx-primary"
                            (click)="addOrder()"
                            tooltip="Add {{ type.name }}"
                            container="body"
                            [disabled]="
                                (type.value === 'work' && !permissionService.isAvailable('jobs.maintain-work-orders.create-work-order')) ||
                                (type.value === 'purchase' &&
                                    !permissionService.isAvailable('jobs.maintain-purchase-orders.create-purchase-order'))
                            ">
                            <i class="ti-plus"></i>
                        </button>
                    </div>
                </li>
                <li>
                    <div class="btn-group dropdown" dropdown>
                        <button
                            id="dropdown-button"
                            type="button"
                            class="btn btn-default dropdown-toggle"
                            dropdownToggle
                            aria-controls="dropdown-settings">
                            <i class="ti-settings"></i> <span class="caret"></span>
                        </button>
                        <ul
                            id="dropdown-settings"
                            class="dropdown-menu dropdown-menu-right no-max-height"
                            *dropdownMenu
                            role="menu"
                            aria-labelledby="dropdown-button">
                            <li>
                                <a
                                    [ngClass]="{
                                        'disabled-link':
                                            (type.value === 'purchase' &&
                                                !permissionService.isAvailable(
                                                    'jobs.maintain-purchase-orders.manage-purchase-order-terms'
                                                )) ||
                                            (type.value === 'work' &&
                                                !permissionService.isAvailable('jobs.maintain-work-orders.manage-work-order-terms')),
                                    }"
                                    (click)="termsAndConditions()"
                                    ><i class="ti-comment-alt"></i> Manage Terms and Conditions</a
                                >
                            </li>
                            @if (!featureService.isAvailable('compact-jobs')) {
                                <li>
                                    <a
                                        [ngClass]="{
                                            'disabled-link':
                                                (type.value === 'purchase' &&
                                                    !permissionService.isAvailable(
                                                        'jobs.maintain-purchase-orders.print-email-purchase-order-list'
                                                    )) ||
                                                (type.value === 'work' &&
                                                    !permissionService.isAvailable(
                                                        'jobs.maintain-work-orders.print-email-work-order-list'
                                                    )) ||
                                                orderCounts().all === 0,
                                        }"
                                        (click)="printPurchaseOrdersList()"
                                        ><i class="ti-printer"></i> Print Orders List</a
                                    >
                                </li>
                                <li>
                                    <a
                                        [ngClass]="{ 'disabled-link': isEmailOrderListDisabled || orderCounts().all === 0 }"
                                        (click)="emailPurchaseOrdersList()"
                                        ><i class="ti-email"></i> Email Orders List</a
                                    >
                                </li>
                            }
                        </ul>
                    </div>
                </li>
            </ul>
        </div>
        <div class="panel-body">
            <div class="row">
                <div class="col-xs-12">
                    <div class="btn-group btn-group-xs" role="group">
                        <button
                            type="button"
                            class="mr-1"
                            [ngClass]="statusFilter() !== 'All' ? 'btn-bx-secondary-stroked' : 'btn-bx-secondary'"
                            (click)="statusFilter.set('All')">
                            All <span class="badge badge-light-grey">{{ orderCounts().all }}</span>
                        </button>
                        <button
                            type="button"
                            class="mr-1"
                            [ngClass]="statusFilter() !== 'Unsent' ? 'btn-bx-secondary-stroked' : 'btn-bx-secondary'"
                            (click)="statusFilter.set('Unsent')">
                            Unsent <span class="badge badge-light-grey">{{ orderCounts().unsent }}</span>
                        </button>
                        <button
                            type="button"
                            class="mr-1"
                            [ngClass]="statusFilter() !== 'Sent' ? 'btn-bx-secondary-stroked' : 'btn-bx-secondary'"
                            (click)="statusFilter.set('Sent')">
                            Sent <span class="badge badge-light-grey">{{ orderCounts().sent }}</span>
                        </button>
                        <button
                            *ngIf="type.value === 'purchase'"
                            type="button"
                            class="mr-1"
                            [ngClass]="statusFilter() !== 'PartReceived' ? 'btn-bx-secondary-stroked' : 'btn-bx-secondary'"
                            (click)="statusFilter.set('PartReceived')">
                            Part Received <span class="badge badge-light-grey">{{ orderCounts().partreceived }}</span>
                        </button>
                        <button
                            *ngIf="type.value === 'purchase'"
                            type="button"
                            class="mr-1"
                            [ngClass]="statusFilter() !== 'Received' ? 'btn-bx-secondary-stroked' : 'btn-bx-secondary'"
                            (click)="statusFilter.set('Received')">
                            Received <span class="badge badge-light-grey">{{ orderCounts().received }}</span>
                        </button>
                        <button
                            *ngIf="type.value === 'work'"
                            type="button"
                            class="mr-1"
                            [ngClass]="statusFilter() !== 'Completed' ? 'btn-bx-secondary-stroked' : 'btn-bx-secondary'"
                            (click)="statusFilter.set('Completed')">
                            Completed <span class="badge badge-light-grey">{{ orderCounts().completed }}</span>
                        </button>

                        <button
                            type="button"
                            class="mr-1"
                            [ngClass]="statusFilter() !== 'Cancelled' ? 'btn-bx-secondary-stroked' : 'btn-bx-secondary'"
                            (click)="statusFilter.set('Cancelled')">
                            Cancelled <span class="badge badge-light-grey">{{ orderCounts().cancelled }}</span>
                        </button>
                    </div>
                </div>
            </div>

            <div class="table-wrapper margin-top-15" #tableWrapper>
                <ngx-datatable
                    #ordersTable
                    class="material bxt-table"
                    [rows]="rows()"
                    [rowHeight]="40"
                    columnMode="force"
                    [headerHeight]="50"
                    [footerHeight]="50"
                    [virtualization]="false"
                    [scrollbarV]="true"
                    [sorts]="[{ prop: 'orderDate', dir: 'desc' }]">
                    <!-- columns  -->
                    <ngx-datatable-column name="Order #" prop="orderNumber" [flexGrow]="1" [minWidth]="75">
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            <a
                                class="bxt-row-action"
                                [ngClass]="{
                                    'disabled-link':
                                        (type.name === 'purchase' &&
                                            !permissionService.isAvailable('jobs.maintain-purchase-orders.view-purchase-orders')) ||
                                        (type.name === 'work' &&
                                            !permissionService.isAvailable('jobs.maintain-work-orders.view-work-orders')),
                                }"
                                (click)="viewOrder(row)">
                                {{ row.orderNumberString }}
                                <i *ngIf="row.hasInvoiceAccSyncData" class="ti-cloud-up" [tooltip]="row.syncTooltip" container="body"></i>
                            </a>
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column name="Description" prop="description" [flexGrow]="8">
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            <a
                                class="bxt-row-action"
                                [ngClass]="{
                                    'disabled-link':
                                        (type.name === 'purchase' &&
                                            !permissionService.isAvailable('jobs.maintain-purchase-orders.view-purchase-orders')) ||
                                        (type.name === 'work' &&
                                            !permissionService.isAvailable('jobs.maintain-work-orders.view-work-orders')),
                                }"
                                (click)="viewOrder(row)">
                                {{ row.description }}
                            </a>
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column name="Supplier #" prop="supplierInvoiceRef" [flexGrow]="2" *ngIf="type.value === 'purchase'">
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            <span [tooltip]="row.supplierInvoiceRef" container="body" containerClass="poTooltip">{{
                                row.supplierInvoiceRef
                            }}</span>
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column
                        [name]="type.value === 'work' ? 'Assigned To' : 'Supplier'"
                        prop="supplierDescription"
                        [flexGrow]="4">
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            {{ row.supplierDescription }}
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column name="Created" prop="orderDate" [flexGrow]="2">
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            {{ row.orderDate | date }}
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column name="Required" prop="requiredByDateLocal" [flexGrow]="2">
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            {{ row.requiredByDateLocal | date }}
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column name="Total (Ex)" prop="orderTotalExTax" [flexGrow]="2">
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            {{ row.orderTotalExTax | bxCurrency }}
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column name="Status" prop="orderStatus" [flexGrow]="2">
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            <span
                                class="label"
                                [ngClass]="{
                                    'label-inverse': row.orderStatus === 'Unsent',
                                    'label-warning': row.orderStatus === 'Sent',
                                    'label-info': row.orderStatus === 'PartReceived',
                                    'label-success': row.orderStatus === 'Received' || row.orderStatus === 'Completed',
                                    'label-danger': row.orderStatus === 'Cancelled',
                                }"
                                >{{ row.orderStatus }}</span
                            >
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column
                        [width]="120"
                        [sortable]="false"
                        [canAutoResize]="false"
                        [draggable]="false"
                        [resizeable]="false"
                        [cellClass]="'right-align'"
                        [headerClass]="'disabled'">
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            <button
                                type="button"
                                class="btn btn-xs btn-info margin-left-5"
                                [disabled]="disableModify"
                                (click)="addOrderInvoice(row)"
                                tooltip="Add Invoice/Receipt"
                                container="body"
                                [adaptivePosition]="false"
                                *ngIf="row.orderType === 'purchase' && (row.orderStatus === 'Sent' || row.orderStatus === 'PartReceived')">
                                <i class="ti-receipt"></i>
                            </button>
                            <button
                                *ngIf="isAllowedToPrint"
                                (click)="printPurchaseOrder(row)"
                                class="btn btn-xs btn-default margin-left-5"
                                tooltip="Print order"
                                [adaptivePosition]="false"
                                container="body">
                                <i class="ti-printer"></i>
                            </button>
                            <button
                                *ngIf="isAllowedToEmail"
                                (click)="emailPurchaseOrder(row)"
                                class="btn btn-xs btn-default margin-left-5"
                                tooltip="Email order"
                                [adaptivePosition]="false"
                                container="body">
                                <i class="ti-email"></i>
                            </button>
                            <button
                                type="button"
                                class="btn btn-xs btn-danger margin-left-5"
                                [disabled]="!permissionService.isAvailable('jobs.maintain-purchase-orders.delete-purchase-order')"
                                (click)="deleteJobOrder($event, row)"
                                *ngIf="row.orderStatus === 'Unsent'"
                                tooltip="Delete order"
                                [adaptivePosition]="false"
                                container="body">
                                <i class="ti-trash"></i>
                            </button>
                        </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-footer>
                        <ng-template ngx-datatable-footer-template let-rowCount="rowCount">
                            <span class="ml-3">{{ rowCount }} total</span>
                        </ng-template>
                    </ngx-datatable-footer>
                </ngx-datatable>
            </div>
        </div>
    </div>

    <help-note-wrapper
        *ngIf="type.value !== 'work'"
        title="{{ 'helpNotes.jobs.purchaseOrders.title' | translate }}"
        url="{{ 'helpNotes.jobs.purchaseOrders.url' | translate }}"
        footer="Read more in our FAQ’s"
        setting="NoteJobOrderList"
        [expanded]="true"
        [videoUrl]="'helpNotes.jobs.purchaseOrders.video-url' | translate">
        {{ 'helpNotes.jobs.purchaseOrders.text' | translate }}
    </help-note-wrapper>

    <help-note-wrapper
        *ngIf="type.value === 'work'"
        title="{{ 'helpNotes.jobs.workOrders.title' | translate }}"
        url="{{ 'helpNotes.jobs.workOrders.url' | translate }}"
        footer="Read more in our FAQ’s"
        setting="NoteJobOrderList"
        [expanded]="true"
        [videoUrl]="'helpNotes.jobs.workOrders.video-url' | translate">
        {{ 'helpNotes.jobs.workOrders.text' | translate }}
    </help-note-wrapper>
</ng-container>
